import { type FC } from 'react'
import { twMerge } from 'tailwind-merge'
import { type DefaultProps } from '@egw/components'
import { ChevronLeftIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router'

export interface PageHeaderProps extends DefaultProps {
  /**
   * Screen title
   */
  title: string
  backPath?: string
  textClassName?: string
}

export const PageHeader: FC<PageHeaderProps> = ({
  // Custom component properties
  title,
  // Common default properties for each component
  className,
  id,
  testId,
  ariaLabel,
  backPath,
  textClassName,
}) => {
  const finalClasses = twMerge('flex items-center mb-md gap-2', className)
  const textClasses = twMerge('typo-primary-2xl-light text-text-header', textClassName)

  return (
    <div className={finalClasses}>
      {backPath ? (
        <Link to={backPath} className="inline-flex items-center gap-2 text-text-meta hover:text-text-header">
          <ChevronLeftIcon className="size-6" />
        </Link>
      ) : null}
      <h1
        {...(testId ? { 'data-testid': testId } : {})}
        {...(id ? { id } : {})}
        {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
        className={textClasses}
      >
        {title}
      </h1>
    </div>
  )
}
